import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/builders/$builder_id/marketing/master-plans/$master_plan_id/")({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: "/builders/$builder_id/master-plans/$master_plan_id",
      params: { builder_id: params.builder_id, master_plan_id: params.master_plan_id },
      statusCode: 301,
    });
  },
});
